import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { FormControlLabel, IconButton, Stack, Switch, Tooltip } from "@mui/material";

import { useScoutWriteAccessControl } from "../hooks/useScoutWriteAccessControl";

export type ScoutWriteAccessToggleProps = {
  value: boolean;
  disabled: boolean;
  onChange: (next: boolean) => void;
  variant?: "inline" | "menu";
};

export function ScoutWriteAccessToggle({
  value,
  disabled,
  onChange,
  variant = "inline",
}: ScoutWriteAccessToggleProps) {
  const { isFeatureEnabled, switchLabel, infoTooltip } = useScoutWriteAccessControl({
    allowMutations: value,
    onAllowMutationsChange: onChange,
    disabled,
  });

  if (!isFeatureEnabled) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={variant === "menu" ? { px: 2, py: 1.5 } : { px: 2, py: 0.5 }}
    >
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={value}
            disabled={disabled}
            onChange={(event) => onChange(event.target.checked)}
            slotProps={{ input: { role: "switch" } }}
          />
        }
        label={switchLabel}
      />
      <Tooltip title={infoTooltip}>
        <IconButton size="small" aria-label="More info about the Scout write-access toggle">
          <InfoOutlined fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
